import { createSelector } from 'reselect';

const selectCanvas = (state) => state.canvas;

export const selectDiagramMembers = createSelector(
    [selectCanvas],
    (canvas) => canvas.diagramMembers
);

export const selectDiagramInvites = createSelector(
    [selectCanvas],
    (canvas) => canvas.diagramInvites
);
